export default __webpack_public_path__ + "static/media/1.5ddc11bc.png";